import { MutationCache, QueryCache, QueryClient } from 'react-query';
import { isExpiredError } from './api';
import { queryKeys } from './queryKeys';

// 画面を開いたまま期限が切れた場合、日程調整を取り直して Layout に期限切れ画面を出させる
const refetchScheduleAdjustmentIfExpired = (error: unknown) => {
  if (!isExpiredError(error)) return;
  queryClient.invalidateQueries(queryKeys.directScheduleAdjustment);
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // 日程調整自体のエラーは Layout が扱う（ここで取り直すと無限ループになる）
      if (query.queryKey[0] === queryKeys.directScheduleAdjustment) return;
      refetchScheduleAdjustmentIfExpired(error);
    }
  }),
  mutationCache: new MutationCache({
    onError: (error) => refetchScheduleAdjustmentIfExpired(error)
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity
    }
  }
});
